// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../button';
import { getLoadMoreLink, receivedNews } from '../../../store/news';
import { fetchData } from '../../../helpers';
import { getNewsLoadMoreLabel } from '../../../store/newsSettings';

type StateProps = {|
  link: ?string,
  loadMoreLabel: string,
|};

type DispatchProps = {|
  getNextItems: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

class LoadMore extends Component<Props> {
  getMoreItems = async () => {
    const { getNextItems, link } = this.props;
    const { json } = await fetchData({ endpoint: link ? `?slug=${link}` : '' });
    const { news } = json;
    getNextItems(news);
  };

  render() {
    const {
      link,
      loadMoreLabel,
    } = this.props;
    return link
      ? (
        <Button
          caret={false}
          colors="primary"
          variant="ghost"
          onClick={() => this.getMoreItems()}
        >
          {loadMoreLabel}
        </Button>
      ) : null;
  }
}

const mapStateToProps = (state): StateProps => ({
  link: getLoadMoreLink(state),
  loadMoreLabel: getNewsLoadMoreLabel(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  getNextItems: news => dispatch(receivedNews(news)),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(LoadMore);
